import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { User, Truck, Package, Milk } from 'lucide-react';
import MyNavbar from '../../../components/customer/navbar/MyNavbar'; // Adjust path as needed
import '../../../assets/styles/customer/RoleSelection.css';

const RoleSelection = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 'customer',
      title: 'Customer Login',
      description: 'Access your milk subscription and delivery history',
      icon: User,
      iconBg: '#f3e8ff',
      iconColor: '#8b5cf6',
      borderColor: '#e9d5ff',
      loginPath: '/customer/login'
    },
    {
      id: 'distributor',
      title: 'Distributor Login',
      description: 'Manage your customers and daily deliveries',
      icon: Truck,
      iconBg: '#e8f5e9',
      iconColor: '#4caf50',
      borderColor: '#c8e6c9',
      loginPath: '/distributor/login'
    },
    // {
    //   id: 'supplier',
    //   title: 'Supplier Login',
    //   description: 'Manage distributors and milk supply chain',
    //   icon: Package,
    //   iconBg: '#f3e8ff',
    //   iconColor: '#8b5cf6',
    //   borderColor: '#e9d5ff',
    //   loginPath: '/supplier/login'
    // }
  ];

  return (
    <>
      {/* Include Navbar */}
      <MyNavbar />
      
      <div className="role-selection-page">
        <Container>
          <div className="role-selection-header">
            <div className="role-selection-brand-icon">
              <Milk size={40} strokeWidth={2} />
            </div>
            <h1 className="role-selection-title">
              Welcome Back to <span className="role-selection-brand">MilkyWay</span>
            </h1>
            <p className="role-selection-subtitle">Select your role to continue</p>
          </div>

          <Row className="justify-content-center g-3 g-lg-4">
            {roles.map((role, index) => (
              <Col xs={12} sm={6} lg={4} key={role.id}>
                <Card 
                  className="role-selection-card"
                  style={{ 
                    animationDelay: `${index * 0.1}s`,
                    borderColor: role.borderColor
                  }}
                >
                  <Card.Body>
                    <div 
                      className="role-selection-icon"
                      style={{ 
                        backgroundColor: role.iconBg,
                        border: `2px solid ${role.borderColor}`
                      }}
                    >
                      <role.icon size={32} style={{ color: role.iconColor }} strokeWidth={1.8} />
                    </div>
                    <h3 className="role-selection-card-title">{role.title}</h3>
                    <p className="role-selection-card-desc">{role.description}</p>
                    <Button className="role-selection-login-btn" onClick={() => navigate(role.loginPath)}>
                      Login
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="role-selection-footer">
            <p>Don't have an account? </p>
            <button className="role-selection-link" onClick={() => navigate('/customer/signup')}>
              Sign up as Customer
            </button>
            <span> • </span>
            <button className="role-selection-link" onClick={() => navigate('/distributor/signup')}>
              Become a Distributor
            </button>
          </div>
        </Container>

        <footer className="role-selection-site-footer">
          <Container>
            <Row>
              <Col md={4}>
                <div className="role-selection-footer-brand">
                  <div className="role-selection-footer-icon">
                    <Milk size={24} strokeWidth={2} />
                  </div>
                  <span>MilkFlow</span>
                </div>
                <p className="role-selection-footer-tagline">
                  Simplifying daily delivery management for Pakistan's local milk supply chain.
                </p>
              </Col>
              <Col md={2}>
                <h5 className="role-selection-footer-heading">Product</h5>
                <ul className="role-selection-footer-links">
                  <li><a href="#pricing">Pricing</a></li>
                  <li><a href="#about">About</a></li>
                  <li><a href="#contact">Contact</a></li>
                </ul>
              </Col>
              <Col md={3}>
                <h5 className="role-selection-footer-heading">For Users</h5>
                <ul className="role-selection-footer-links">
                  <li><a href="/customer/signup">Customer Signup</a></li>
                  <li><a href="/customer/login">Login</a></li>
                </ul>
              </Col>
              <Col md={3}>
                <h5 className="role-selection-footer-heading">For Distributors</h5>
                <ul className="role-selection-footer-links">
                  <li><a href="/distributor/signup">Become a Distributor</a></li>
                  <li><a href="/distributor/login">Distributor Login</a></li>
                </ul>
              </Col>
            </Row>
            <div className="role-selection-footer-bottom">
              <p>© 2024 MilkFlow. All rights reserved.</p>
            </div>
          </Container>
        </footer>
      </div>
    </>
  );
};

export default RoleSelection;